<!--
component: MapPane
author: Izumi
description: 検索条件入力画面：通常モード検索条件入力
-->
<template>
	<section class="search-attr">
		<v-container fluid class="pa-0">
			<div class="head-message mb-1">{{ headMessage }}</div>
			<v-row justify="center" class="my-1">
				<v-col cols="11" class="pt-1 px-0">
					<v-card>
						<v-card-title class="py-1">
							検索対象からはずすには、項目名（<v-icon>mdi-checkbox-outline</v-icon>）を押して切り替えて下さい。
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text class="ma-1 py-2 justify-center">
							<v-form ref="form" v-model="valid" lazy-validation>
                <v-item-group
                  v-model="selected"
                  multiple
                >
								<!-- 一般計画（必須）項目 -->
								<v-row>
									<v-col class="py-0">
										<v-row class="ma-1" align="center">
											<v-col cols="12" sm="12" md="5" lg="4" class="text-left item-name py-1">
												一般計画（必須）
											</v-col>
											<v-col class="py-1" cols="12" sm="12" md="7" lg="8">
												<v-btn-toggle v-model="ipan_plan_kubun" multiple mandatory color="blue" dense>
													<v-btn active-class="light-blue darken-3 white--text" tabindex="1">一般</v-btn>
													<v-btn active-class="light-blue darken-3 white--text" tabindex="2">計画通知</v-btn>
												</v-btn-toggle>
												<!--
												<v-select :items="kubunList" item-text="name"
																:background-color="!active ? '' : 'grey lighten-1'" v-model="ipan_plan_kubun" hide-details solo
																dense placeholder="一般計画"></v-select>
												-->
											</v-col>
										</v-row>
									</v-col>
									<v-col></v-col>
								</v-row>
								<v-divider class="my-2"></v-divider>


								<!-- 受付年度、番号 項目 -->
								<v-row class="py-0">
									<v-col cols="12" class="py-0 pr-lg-0 pr-md-0" sm="12" md="6" lg="6">
										<v-item v-slot="{ active, toggle }">
											<v-row class="ma-1" align="center" :class="!active ? '' : 'grey lighten-1'">
												<v-col>
													<v-row align="center">
														<v-col cols="12" sm="4" md="4" lg="4" id="rcpFiscalYear" class="text-left item-name"
															@click="toggle" @keydown.space="toggle" tabindex=3>
															<v-row align="center">
																<v-col cols="2" align="center"><v-icon>{{ !active ? 'mdi-checkbox-outline' :
																	'mdi-checkbox-blank-outline' }}</v-icon></v-col>
																<v-col cols="10" align="left"><span>受付年度</span></v-col>
															</v-row>
														</v-col>
														<v-col>
															<v-row class="py-0">
																<v-col cols="12" sm="6" md="6" lg="6" align-self="center" class="py-1">
																	<v-select :items="eraList" :background-color="!active ? '' : 'grey lighten-1'"
																		item-text="era" @change="rcpYearSelected()" v-model="gengo" hide-details solo dense
																		placeholder="元号" :disabled="active" tabindex="4">
																	</v-select>
																</v-col>
																<v-col cols="12" sm="6" md="6" lg="6" class="py-1">
																	<v-combobox :items="rcpYearItems" :background-color="!active ? '' : 'grey lighten-1'"
																		item-text="fiscalYear" v-model="nen" solo dense no-data-text="選択可能なデータはありません。"
																		hide-details placeholder="年度" :disabled="active" tabindex="5"></v-combobox>
																</v-col>
															</v-row>
															<v-alert dence text type="error" v-show="rcpYearErrMsg" class="pa-1 mt-3 mb-0">{{
																rcpYearErrMsg }}</v-alert>
															<v-alert class="mt-3 mb-0" v-show="!rcpYearErrMsg && rcpNo1ErrMsg"></v-alert>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</v-item>
									</v-col>

								</v-row>
								<v-divider class="my-2"></v-divider>

								<!-- 区・番号 -->
								<v-row>
									<v-col cols="12" class="py-0 pr-lg-0 pr-md-0" sm="12" md="6" lg="6">
										<v-item v-slot="{ active, toggle }">
											<v-row class="ma-1" align="center" :class="!active ? '' : 'grey lighten-1'">
												<v-col cols="12" sm="4" md="4" lg="4" class="text-left item-name" @click="toggle"
													@keydown.space="toggle" tabindex="6">
													<v-row align="center">
														<v-col cols="2" align="center"><v-icon>{{ !active ? 'mdi-checkbox-outline' :
															'mdi-checkbox-blank-outline' }}</v-icon></v-col>
														<v-col cols="10" align="left"><span>区</span></v-col>
													</v-row>
												</v-col>
												<v-col class="pb-1">
													<v-row class="mb-0">
														<v-col cols="12" sm="12" md="6" lg="4" align-self="center" class="py-1">
															<v-select :items="wardList" item-text="name"
																:background-color="!active ? '' : 'grey lighten-1'" v-model="gyosei_kubun" hide-details
																solo dense placeholder="区名" :disabled="active" tabindex="7"></v-select>
															<v-alert dence text type="error" v-show="placeLotNoErrMsg" class="pa-1 mt-3 mb-0">{{
																placeLotNoErrMsg }}</v-alert>

														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</v-item>
									</v-col>

									<!--仕切り線 横軸中央-->
									<v-divider vertical class="my-1" v-show="['md', 'lg'].includes($vuetify.breakpoint.name)"></v-divider>
									<!--仕切り線 横軸中央-->

									<v-col cols="12" class="py-0 pl-lg-0 pl-md-0" sm="12" md="6" lg="6">
										<v-item v-slot="{ active, toggle }">
											<v-row class="ma-1" align="center" :class="!active ? '' : 'grey lighten-1'">
												<v-col cols="12" sm="4" md="4" lg="3" id="rcpNo1" class="pa-2 text-left item-name" @click="toggle"
													@keydown.space="toggle" tabindex="8">
													<v-row align="center">
														<v-col cols="2" align="center"><v-icon>{{ !active ? 'mdi-checkbox-outline' :
															'mdi-checkbox-blank-outline' }}</v-icon></v-col>
														<v-col cols="10" align="left"><span>番号</span></v-col>
													</v-row>
													<!-- <span><v-icon>{{!active ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'}}</v-icon> 番号</span> -->
												</v-col>
												<v-col>
													<v-row>
														<v-col class="py-1">
															<v-text-field id="rcpNum" ref="rcpNum" type="tel" autocomplete="nope"
																placeholder="1~99999で入力してください。" v-model="bango" outlined hide-details hide-spin-buttons
																min="1" max="99999" dense :disabled="active" tabindex="9"></v-text-field>
														</v-col>
													</v-row>
													<v-alert dence text type="error" v-show="rcpNo1ErrMsg" class="pa-1 mt-3 mb-0">{{ rcpNo1ErrMsg
													}}</v-alert>
													<v-alert class="mt-3 mb-0" v-show="rcpYearErrMsg && !rcpNo1ErrMsg"></v-alert>
												</v-col>
											</v-row>
										</v-item>
									</v-col>
								</v-row>

								<!--仕切り線 縦軸-->
								<v-divider class="my-2"></v-divider>


								<!-- 所在地 ※建築主のコピペ -->
								<v-row>
									<v-col class="py-0">
										<v-item v-slot="{ active, toggle }">
											<v-row class="ma-1" align="center" :class="!active ? '' : 'grey lighten-1'">
												<v-col cols="12" sm="4" md="2" lg="2" class="text-left item-name" @click="toggle"
													@keydown.space="toggle" tabindex="10">
													<v-row align="center">
														<v-col cols="2" align="center"><v-icon>{{ !active ? 'mdi-checkbox-outline' :
															'mdi-checkbox-blank-outline' }}</v-icon></v-col>
														<v-col cols="10" align="left"><span>物件所在地</span></v-col>
													</v-row>
												</v-col>
												<v-col class="pb-1">
													<v-row class="mb-0">
														<v-col class="py-1">
															<v-text-field v-model="bkn_addr" outlined hide-details dense :disabled="active" tabindex="11">
															</v-text-field>
														</v-col>
													</v-row>
													<v-alert dence text type="error" v-show="initRepArchitectErrMsg" class="pa-1 mt-1 mb-0">{{
														initRepArchitectErrMsg }}</v-alert>
												</v-col>
											</v-row>
										</v-item>
									</v-col>
								</v-row>
								<v-divider class="my-2"></v-divider>


								<!-- 建築主 -->
								<v-row>
									<v-col class="py-0">
										<v-item v-slot="{ active, toggle }">
											<v-row class="ma-1" align="center" :class="!active ? '' : 'grey lighten-1'">
												<v-col cols="12" sm="4" md="2" lg="2" class="text-left item-name" @click="toggle"
													@keydown.space="toggle" tabindex="12">
													<v-row align="center">
														<v-col cols="2" align="center"><v-icon>{{ !active ? 'mdi-checkbox-outline' :
															'mdi-checkbox-blank-outline' }}</v-icon></v-col>
														<v-col cols="10" align="left"><span>建築主氏名</span></v-col>
													</v-row>
												</v-col>
												<v-col class="pb-1">
													<v-row class="mb-0">
														<v-col class="py-1">
															<v-text-field v-model="bldr_name" outlined hide-details dense :disabled="active" tabindex="13">
															</v-text-field>
														</v-col>
													</v-row>
													<v-alert dence text type="error" v-show="initRepArchitectErrMsg" class="pa-1 mt-1 mb-0">{{
														initRepArchitectErrMsg }}</v-alert>
												</v-col>
											</v-row>
										</v-item>
									</v-col>
								</v-row>
								<v-divider class="my-2"></v-divider>


								<!-- 主用途 ※区のコピペ -->
								<v-row>
									<v-col cols="12" class="py-0 pr-lg-0 pr-md-0" sm="12" md="6" lg="6">
										<v-item v-slot="{ active, toggle }">
											<v-row class="ma-1" align="center" :class="!active ? '' : 'grey lighten-1'">
												<v-col cols="12" sm="4" md="4" lg="4" class="text-left item-name" @click="toggle"
													@keydown.space="toggle" tabindex="14">
													<v-row align="center">
														<v-col cols="2" align="center"><v-icon>{{ !active ? 'mdi-checkbox-outline' :
															'mdi-checkbox-blank-outline' }}</v-icon></v-col>
														<v-col cols="10" align="left"><span>主要用途</span></v-col>
													</v-row>
												</v-col>
												<v-col class="pb-1">
													<v-row class="mb-0">
														<v-col cols="12" sm="12" md="6" lg="4" align-self="center" class="py-1">
															<v-combobox ref="syuyoCombobox" :items="syuyoList" item-text="name"
																:background-color="!active ? '' : 'grey lighten-1'" v-model="syuyo_yoto" hide-details solo
																dense placeholder="主用途" :disabled="active" tabindex="15"></v-combobox>
															<v-alert dence text type="error" v-show="placeLotNoErrMsg" class="pa-1 mt-3 mb-0">{{
																placeLotNoErrMsg }}</v-alert>

														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</v-item>
									</v-col>
								</v-row>

								<!--仕切り線 縦軸-->
								<v-divider class="my-2"></v-divider>


								<!-- 申請年月日 -->
								<v-row class="py-0">
									<v-col class="py-0">
										<v-item v-slot="{ active, toggle }">
											<v-row class="ma-1" align="center" :class="!active ? '' : 'grey lighten-1'">
												<v-col cols="12" sm="4" md="2" lg="2" class="text-left item-name" @click="toggle"
													@keydown.space="toggle" tabindex="16">
													<v-row align="center">
														<v-col cols="2" align="center"><v-icon>{{ !active ? 'mdi-checkbox-outline' :
															'mdi-checkbox-blank-outline' }}</v-icon></v-col>
														<v-col cols="10" align="left"><span>受付年月日</span></v-col>
													</v-row>
												</v-col>
												<v-col class="py-0">
													<v-row align="center" class="ma-1">
														<v-col cols="12" sm="5" md="5" lg="5" class="py-0 pl-0">
															<DatePicker ref="cnfUkeStartDate" v-model="uke_day_from" @clear="uke_day_from = $event"
																:active="active" tabindex="17"/>
														</v-col>
														<v-col cols="12" sm="2" md="1" lg="1" class="text-center py-2 pl-0" justify="center">～</v-col>
														<v-col cols="12" sm="5" md="5" lg="5" class="py-0 pl-0">
															<DatePicker ref="cnfUkeEndDate" v-model="uke_day_until" @clear="uke_day_until = $event"
																:active="active" tabindex="18"/>
														</v-col>
													</v-row>
													<v-alert dence text type="error" v-show="cnfDateErrMsg" class="pa-1 mt-1 mb-0">{{ cnfDateErrMsg
													}}</v-alert>
												</v-col>
											</v-row>
										</v-item>
									</v-col>
								</v-row>
								<v-divider class="my-2"></v-divider>


								<!-- 確認年月日 -->
								<v-row class="py-0">
									<v-col class="py-0">
										<v-item v-slot="{ active, toggle }">
											<v-row class="ma-1" align="center" :class="!active ? '' : 'grey lighten-1'">
												<v-col cols="12" sm="4" md="2" lg="2" class="text-left item-name" @click="toggle"
													@keydown.space="toggle" tabindex="19">
													<v-row align="center">
														<v-col cols="2" align="center"><v-icon>{{ !active ? 'mdi-checkbox-outline' :
															'mdi-checkbox-blank-outline' }}</v-icon></v-col>
														<v-col cols="10" align="left"><span>確認年月日</span></v-col>
													</v-row>
												</v-col>
												<v-col class="py-0">
													<v-row align="center" class="ma-1">
														<v-col cols="12" sm="5" md="5" lg="5" class="py-0 pl-0">
															<DatePicker ref="cnfKnnStartDate" v-model="kknn_day_from" @clear="kknn_day_from = $event"
																:active="active" tabindex="20"/>
														</v-col>
														<v-col cols="12" sm="2" md="1" lg="1" class="text-center py-2 pl-0" justify="center">～</v-col>
														<v-col cols="12" sm="5" md="5" lg="5" class="py-0 pl-0">
															<DatePicker ref="cnfKnnEndDate" v-model="kknn_day_until" @clear="kknn_day_until = $event"
																:active="active" tabindex="21"/>
														</v-col>
													</v-row>
													<v-alert dence text type="error" v-show="cnfDateErrMsg" class="pa-1 mt-1 mb-0">{{ cnfDateErrMsg
													}}</v-alert>
												</v-col>
											</v-row>
										</v-item>
									</v-col>
								</v-row>
								<v-divider class="my-2"></v-divider>


								<!-- 検査済年月日 -->
								<v-row class="py-0">
									<v-col class="py-0">
										<v-item v-slot="{ active, toggle }">
											<v-row class="ma-1" align="center" :class="!active ? '' : 'grey lighten-1'">
												<v-col cols="12" sm="4" md="2" lg="2" class="text-left item-name" @click="toggle"
													@keydown.space="toggle" tabindex="22">
													<v-row align="center">
														<v-col cols="2" align="center"><v-icon>{{ !active ? 'mdi-checkbox-outline' :
															'mdi-checkbox-blank-outline' }}</v-icon></v-col>
														<v-col cols="10" align="left"><span>検査済証交付年月日</span></v-col>
													</v-row>
												</v-col>
												<v-col class="py-0">
													<v-row align="center" class="ma-1">
														<v-col cols="12" sm="5" md="5" lg="5" class="py-0 pl-0">
															<DatePicker ref="cnfKenStartDate" v-model="kenzumi_day_from" @clear="kenzumi_day_from = $event"
																:active="active" tabindex="23"/>
														</v-col>
														<v-col cols="12" sm="2" md="1" lg="1" class="text-center py-2 pl-0" justify="center">～</v-col>
														<v-col cols="12" sm="5" md="5" lg="5" class="py-0 pl-0">
															<DatePicker ref="cnfKenEndDate" v-model="kenzumi_day_until" @clear="kenzumi_day_until = $event"
																:active="active" tabindex="24"/>
														</v-col>
													</v-row>
													<v-alert dence text type="error" v-show="cnfDateErrMsg" class="pa-1 mt-1 mb-0">{{ cnfDateErrMsg
													}}</v-alert>
												</v-col>
											</v-row>
										</v-item>
									</v-col>
								</v-row>
								<v-divider class="my-2"></v-divider>





								<!-- 検索 -->
								<v-row class="mx-1  my-0">
									<v-col class="py-0" :class="['xs', 'sm'].includes($vuetify.breakpoint.name) ? 'px-0' : ''">
										<v-row class="ma-1">
											<v-spacer></v-spacer>
											<v-col cols="12" sm="12" md="3" lg="3" align="center" class="py-0"
												:class="['xs', 'sm'].includes($vuetify.breakpoint.name) ? 'px-0' : ''">
												<!--
												<v-btn color="primary" large block @click="search()" :disabled="serchEnable" tabindex="32">
												-->
												<v-btn  ref="searchButton" color="primary" large block @click="search()" @keydown.enter="search()" tabindex="25">
													検索
												</v-btn>
											</v-col>
											<v-col cols="12" sm="12" md="3" lg="3" align="center" class="py-0"
												:class="['xs', 'sm'].includes($vuetify.breakpoint.name) ? 'mt-4 px-0' : ''">
												<v-btn color="grey lighten-1" large block @click="searchClear()" tabindex="26">
													全ての検索条件をクリア
												</v-btn>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
								</v-item-group>
							</v-form>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
		<Dialog error :open="authDialog" :ok="() => authDialog = false" :to="'/'" :title="'ユーザー認証'"
			:body="'ユーザー認証に失敗しました。ログインし直して下さい。'" />
		<!-- 検索中ダイアログ -->
		<v-dialog id="searchlodingDialog" width="30%" v-model="searchDialog" persistent>
			<v-card>
				<v-card-title class="text-h6 px-5">
					<v-icon large color="primary">mdi-database-search</v-icon>&nbsp;検索中
				</v-card-title>
				<v-card-text class="pb-0">
					<v-progress-linear color="light-blue darken-2" indeterminate rounded height="6"></v-progress-linear>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="cancelSearch()">キャンセル</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- メッセージダイアログ -->
		<v-dialog id="dialog" width="30%" v-model="dialog" persistent>
			<v-card>
				<v-card-title>検索</v-card-title>
				<v-card-text class="pa-0">
					<v-row align="center" class="ma-1">
						<v-col cols="2" class="pa-0" align="center">
							<v-icon large color="error" class="ma-auto" v-if="dialogCategory == 1">mdi-alert</v-icon>
							<v-icon large color="success" class="ma-auto" v-else-if="dialogCategory == 0">mdi-check-circle</v-icon>
						</v-col>
						<v-col cols="10">{{ dialogMsg }}</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="pt-1">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="dialog = false">OK</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>
  
<script>
import DatePicker from '../components/DatePickerWareki.vue'
import Dialog from '../components/Dialog.vue'
import Constants from '../common/constants'
//import { /*searchAttr,*/ callPostApi, callGetApi } from '../common/apiAccess'
import { /*searchAttr,*/ callGetApi } from '../common/apiAccess'
//import { apiUrl, getWardCode, dbglog, gaiyoURL, /*elvUrl,*/ plotUrl, plotUrlAlt, daichoURL } from '../common/utils'
import { apiUrl, dbglog, gaiyoURL, /*elvUrl,*/ plotUrl, plotUrlAlt, daichoURL, /*getWardName,*/ 
	/*getKubunCode,*/ getWardCodeBalics, getWarekiCode, /*getSyuyoCode,*/
	/*getSyuyoName,*/ getWardCodeBalicsName, getWarekiName, /*getKubunName*/} from '../common/utils'

export default {
	components: {
		DatePicker,
		Dialog
	},
	data() {
		return {
      selected: [], // 検索対象有無判定配列 
			serchEnable: true, // 検索ボタン状態制御
			ipan_plan_kubun: [0,1],
			gengo: "",
			nen: "",
			gyosei_kubun: "",
			bango: "",
			bkn_addr: "",
			bldr_name: "",
			syuyo_yoto: "",
			uke_day_from: "",
			uke_day_until: "",
			kknn_day_from: "",
			kknn_day_until: "",
			kenzumi_day_from: "",
			kenzumi_day_until: "",
			cnfDateErrMsg: '',
			rcpYearItems: [], // 受付年度選択制御用変数

      // 検索中フラグ       
      searching: false,
      searchDialog: false,
      dialog: false,
      dialogCategory: 0, // 0:正常(success),1:異常(error)
      dialogMsg: '',

			kubunList:['一般','計画通知'],
			eraList: ['昭和', '平成', '令和'],
			wardList: ['鶴見区','神奈川区','西区','中区','南区','保土ケ谷区','磯子区','金沢区','港北区','戸塚区','港南区','旭区','緑区','瀬谷区','栄区','泉区','青葉区','都筑区','計画通知'],
			syuyoList: ['専用住宅','共同住宅','住宅','長屋','事務所','店舗','事務所併用住宅','店舗併用住宅','工場','倉庫','物置','その他'],
			eraYearList: [],

		}
	},

	props: {
		zoom: {
			type: Number,
			default: 18,
		},
		targetPlot: {
			type: Object,
			default: null,
		},
	},
	created() {
		this.plotUrl = plotUrl();
		this.plotUrlAlt = plotUrlAlt();
		//this.plotDef = constants.tileDef[this.mode];
		if (this.mode == 5) {
			//this.plotDefAlt = constants.tileDef[6];
		}
		dbglog('MapPane:' + this.plotDef);
		if (this.sheetVisible) {
			if (this.mode == 1) {
				//this.sheetUrl = this.$store.state.mapOrigin + constants.tileDef[8].url;
			}
			else if (this.mode == 5) {
				//this.sheetUrl = this.$store.state.mapOrigin + constants.tileDef[9].url;
			}
		}
		if (this.mode == 7) {
			///*
			//this.bgmapList = [
			//	this.$store.state.mapOrigin + constants.tileDef[10].url,
			//	this.$store.state.mapOrigin + constants.tileDef[11].url,
			//];
			//*/
			/*
			this.bgmapList = [];
			if (this.$store.state.seibiSokushinVisible) {
				this.bgmapList.push(this.$store.state.mapOrigin + constants.tileDef[10].url);
			}
			if (this.$store.state.douroShubetsuVisible) {
				this.bgmapList.push(this.$store.state.mapOrigin + constants.tileDef[11].url);
			}
			*/
		}
	},
	mounted() {
		if (this.unauthorized) {
			this.message = 'ユーザー認証されていません。';
			this.$router.replace('/');
		}
		this.$store.commit('setCurrentPage', 5);
		this.setMessage();
		//選択されているプロットの番号が保存されている場合
		if (this.selectedNo) {
			this.searchGaiyo(this.selectedNo, (data) => {
				this.existsGaiyo = (data && data.length);
			});
		}
		this.init();
		this.message = '検索条件を指定してください';
		
		this.rcpYearSelected();

		//this.targetPlotData = this.targetPlot; //ここでは遅い
		//test
		//console.log(this.targetPlot);
	},
	computed: {
		token() {
			return this.$store.state.token;
		},
		unauthorized() {
			return this.token == undefined || this.token == null || this.token.length == 0;
		},
		authorized() {
			return !this.unauthorized;
		},
		headMessage () {
      return "詳細検索";
    },
		message: {
			get() { return this.$store.state.message; },
			set(val) { this.$store.commit('setMessage', val); }
		},
		browsable() {
			return this.isSelected && this.existsGaiyo;
		},
		features: {
			get() { return this.$store.state.features; },
			set(val) { this.$store.commit('setFeatures', val); }
		},
		sheets: {
			get() { return this.$store.state.sheets; }
		},
		mode() {
			return this.$store.state.mode;
		},
		authority() {
			//return this.$store.state.authority;
			return this.$store.state.userInfo.authority;
		},
		sheetVisible() {
			//return (this.authority >= 1) && (this.mode == 1 || this.mode == 5);
			// authority=4 は住所検索と番号検索のみ（仮）
			return (this.authority >= 1 && this.authority != 4) && (this.mode == 1 || this.mode == 5);
		},
		douroShubetsuVisible: {
			get() {
				return this.$store.state.douroShubetsuVisible;
			},
			set(val) {
				this.$router.commit('setDouroShubetsuVisible', val);
			}
		},
		gaiyoId() {
			return this.$store.state.gaiyoId;
		},
		gaiyo() {
			return this.$store.state.gaiyoData;
		},
		selectedNo: {
			get() { return this.$store.state.selectedNo; },
			set(val) { this.$store.commit('setSelectedNo', val); }
		},
		selectedId: {
			get() { return this.$store.state.selectedId; },
			set(val) { this.$store.commit('setSelectedId', val); }
		},
		gaiyoList() {
			return this.$store.state.gaiyoList;
		},
		centerx() {
			return this.$store.state.centerx;
		},
		centery() {
			return this.$store.state.centery;
		},
		selectedPlotTitle() {
			let title = this.plotDef.title;
			if (this.plotDefAlt)
				title += '・' + this.plotDefAlt.title;
			return title;
		},
		browseButtonTitle() {
			if (this.mode == 1) {
				return '概要書を閲覧';
			}
			else if (this.mode == 2) {
				return '昇降機台帳を閲覧';
			}
			else if (this.mode == 3) {
				return '定期報告概要書を閲覧';
			}
			else if (this.mode == 5) {
				if (this.selectedLayer == 'vectorLayer')
					return '開発登録簿を閲覧';
				else if (this.selectedLayer == 'vectorLayerAlt')
					return '造成計画平面図を閲覧';
				else
					return '閲覧';
			}
			else {
				return '閲覧';
			}
		},
		isSelected() {
			return this.selectedNo !== undefined && this.selectedNo !== null
				&& this.selectedNo != '';
		},
		wardCode() {
			return this.$store.state.wardCode;
		},
		wardName() {
			return this.$store.state.wardName;
		},
		townCode() {
			return this.$store.state.townCode;
		},
		townName() {
			return this.$store.state.townName;
		},
		oyaban() {
			return this.$store.state.oyaban;
		},
		edaban() {
			return this.$store.state.edaban;
		},
		bottomSheet() {
			return ((this.$store.state.features.length > 0) && (this.$vuetify.breakpoint.name == 'xs'));
		}
	},
	watch: {
		uke_day_from(newValue, oldValue) {
			if(newValue !== oldValue) {
				const datePickerInstance = this.$refs.cnfUkeStartDate;
				datePickerInstance.pickerText = newValue;
				datePickerInstance.inputDate();
			}
		},
		uke_day_until(newValue, oldValue) {
			if(newValue !== oldValue) {
				const datePickerInstance = this.$refs.cnfUkeEndDate;
				datePickerInstance.pickerText = newValue;
				datePickerInstance.inputDate();
			}
		},
		kknn_day_from(newValue, oldValue) {
			if(newValue !== oldValue) {
				const datePickerInstance = this.$refs.cnfKnnStartDate;
				datePickerInstance.pickerText = newValue;
				datePickerInstance.inputDate();
			}
		},
		kknn_day_until(newValue, oldValue) {
			if(newValue !== oldValue) {
				const datePickerInstance = this.$refs.cnfKnnEndDate;
				datePickerInstance.pickerText = newValue;
				datePickerInstance.inputDate();
			}
		},
		kenzumi_day_from(newValue, oldValue) {
			if(newValue !== oldValue) {
				const datePickerInstance = this.$refs.cnfKenStartDate;
				datePickerInstance.pickerText = newValue;
				datePickerInstance.inputDate();
			}
		},
		kenzumi_day_until(newValue, oldValue) {
			if(newValue !== oldValue) {
				const datePickerInstance = this.$refs.cnfKenEndDate;
				datePickerInstance.pickerText = newValue;
				datePickerInstance.inputDate();
			}
		},
		features(newValue, oldValue) {
			dbglog(`MapPane: watch.features(${newValue},${oldValue})`, 2);
			if (newValue != null) {
				if (newValue.length == 0 || newValue.length > 1) {
					this.selectedId = '';
					this.selectedNo = '';
					this.selectedLayer = '';
				}
				else if (newValue.length == 1) {
					this.selectRow(newValue[0]);
				}
			}
		},
		sheets(newValue, oldValue) {
			if ((newValue != oldValue) && !this.queryingSheet) {
				const ku = this.wardCode - 14100;
				let sheets = '';
				for (let i = 0; i < newValue.length; i++) {
					sheets += (sheets.length > 0 ? ',' : '') + newValue[i].indexId;
				}
				let url = '';
				if (this.mode == 1) {
					url = apiUrl('KenkakuPlotIndexNendo') + `?ku=${ku}&sheets=${sheets}`;
				}
				else if (this.mode == 5) {
					url = apiUrl('KaihatsuPlotIndexNendo') + `?ku=${ku}&sheets=${sheets}`;
				}
				else {
					return;
				}
				this.queryingSheet = true;
				callGetApi(url, (data) => {
					this.nendoList = [];
					if (data.length) {
						if (data.length > 10) {
							this.nendoCols = 6;
							this.nendoXlCols = 4;
							this.textClass = 'text-h7';
						}
						else {
							this.nendoCols = 12;
							this.nendoXlCols = 6;
							this.textClass = 'text-h6';
						}
						for (let i = 0; i < data.length; i++) {
							for (let j = 0; j < newValue.length; j++) {
								if (data[i].id == newValue[j].indexId) {
									this.nendoList.push({
										id: data[i].id,
										name: data[i].name,
										pageNo: newValue[j].pageNo,
										branch: newValue[j].branch
									});
									break;
								}
							}
						}
					}
					this.queryingSheet = false;
				});
			}
		},
	},
	methods: {
		searchClear() {
			this.selected = [0,1,2,3,4,5,6,7,8,9];

			this.ipan_plan_kubun = [0,1];
			this.ipan_plan_kubun_v = 0;
			this.gengo = "";
			this.nen = "";
			this.gyosei_kubun = "";
			this.bango = "";
			this.bkn_addr = "";
			this.bldr_name = "";
//			this.syuyo_yoto = getSyuyoName(daichoSearch.syuyo_yoto);
			this.syuyo_yoto = "";
			this.uke_day_from = ""
			this.uke_day_until = "";
			this.kknn_day_from = "";
			this.kknn_day_until = "";
			this.kenzumi_day_from = "";
			this.kenzumi_day_until = "";
		},
		init() {
      this.eraYearList.push({era: '',yearData: []});
      const def = Constants.warekiDef;
      for(let i = 0; i < def.length; i++){
        if(!(def[i].era == '明治' || def[i].era == '大正' || def[i].era == '')){
          const tempArr = [];
          for(let j = 0; j < (def[i].lastNendo - def[i].startNendo + 1); j++){
            tempArr.push(
              // {
              // fiscalYear: def[i].lastNendo - j,
              // year: def[i].firstYear + def[i].lastNendo - j - 1
              def[i].lastNendo - j
              // }
            );
          }
          this.eraYearList.push({
            era: def[i].era,
            yearData:tempArr
          });
        }
      }

//			this.selected = [0,1,2,3,4,5,6,7,8,9];
			this.selected = this.$store.state.daichoSearchSelect;

      var daichoSearch = this.$store.state.daichoSearch;
//			this.ipan_plan_kubun = getKubunName(daichoSearch.ipan_plan_kubun);
			if(!daichoSearch.ipan_plan_kubun){
				daichoSearch.ipan_plan_kubun = [0,1];
			}
			this.ipan_plan_kubun = daichoSearch.ipan_plan_kubun;

			this.gengo = getWarekiName(daichoSearch.gengo);
			this.nen = daichoSearch.nen;
			this.gyosei_kubun = getWardCodeBalicsName(daichoSearch.gyosei_kubun);
			this.bango = daichoSearch.bango;
			this.bkn_addr = daichoSearch.bkn_addr;
			this.bldr_name = daichoSearch.bldr_name;
//			this.syuyo_yoto = getSyuyoName(daichoSearch.syuyo_yoto);
			this.syuyo_yoto = daichoSearch.syuyo_yoto;
			this.uke_day_from = daichoSearch.uke_day_from;
			this.uke_day_until = daichoSearch.uke_day_until;
			this.kknn_day_from = daichoSearch.kknn_day_from;
			this.kknn_day_until = daichoSearch.kknn_day_until;
			this.kenzumi_day_from = daichoSearch.kenzumi_day_from;
			this.kenzumi_day_until = daichoSearch.kenzumi_day_until;
		},
		makePostData() {
			var postData = {};

//			postData.ipan_plan_kubun = getKubunCode(this.ipan_plan_kubun);
			postData.ipan_plan_kubun = this.ipan_plan_kubun;
			if (!this.selected.includes(0)) {
				postData.gengo = getWarekiCode(this.gengo);
				if(postData.gengo==0) {postData.gengo="";}
				postData.nen = this.nen;
			}

			if (!this.selected.includes(1)) {
				postData.gyosei_kubun = getWardCodeBalics(this.gyosei_kubun);
				if(postData.gyosei_kubun==14000) {postData.gyosei_kubun="";}
			}

			if (!this.selected.includes(2)) {
				postData.bango = this.bango;
			}	

			if (!this.selected.includes(3)) {
				postData.bkn_addr = this.bkn_addr;
			}	

			if (!this.selected.includes(4)) {
				postData.bldr_name = this.bldr_name;
			}

			if (!this.selected.includes(5)) {
//			postData.syuyo_yoto = getSyuyoCode(this.syuyo_yoto);
				postData.syuyo_yoto = this.syuyo_yoto;
				if(postData.syuyo_yoto==0) {postData.syuyo_yoto="";}
			}	

			if (!this.selected.includes(6)) {
				postData.uke_day_from = this.uke_day_from;
				postData.uke_day_until = this.uke_day_until;
			}	

			if (!this.selected.includes(7)) {
				postData.kknn_day_from = this.kknn_day_from;
				postData.kknn_day_until = this.kknn_day_until;
			}	

			if (!this.selected.includes(8)) {
				postData.kenzumi_day_from = this.kenzumi_day_from;
				postData.kenzumi_day_until = this.kenzumi_day_until;
			}	

			return (postData);
		},
		makeStoreData() {
			var postData = {};

//			postData.ipan_plan_kubun = getKubunCode(this.ipan_plan_kubun);
			postData.ipan_plan_kubun = this.ipan_plan_kubun;
			postData.gengo = getWarekiCode(this.gengo);
			if(postData.gengo==0) {postData.gengo="";}
			postData.nen = this.nen;

			postData.gyosei_kubun = getWardCodeBalics(this.gyosei_kubun);
			if(postData.gyosei_kubun==14000) {postData.gyosei_kubun="";}

			postData.bango = this.bango;

			postData.bkn_addr = this.bkn_addr;

			postData.bldr_name = this.bldr_name;

//			postData.syuyo_yoto = getSyuyoCode(this.syuyo_yoto);
			postData.syuyo_yoto = this.syuyo_yoto;
			if(postData.syuyo_yoto==0) {postData.syuyo_yoto="";}

			postData.uke_day_from = this.uke_day_from;
			postData.uke_day_until = this.uke_day_until;

			postData.kknn_day_from = this.kknn_day_from;
			postData.kknn_day_until = this.kknn_day_until;

			postData.kenzumi_day_from = this.kenzumi_day_from;
			postData.kenzumi_day_until = this.kenzumi_day_until;

			return (postData);
		},
		async search() {
			this.$refs.syuyoCombobox.blur();
//			this.$refs.syuyoCombobox.focus();
			await this.$nextTick();

			var store_value = this.makeStoreData();
			var value = this.makePostData();
			this.$store.commit('setDaichoSearchSelect', this.selected);
			this.$store.commit('setDaichoSearch', store_value);
			console.log(value);

			var ipan_plan_kubun = 0;
			for(var i = 0; i < value.ipan_plan_kubun.length; i++) {
				ipan_plan_kubun += (value.ipan_plan_kubun[i]+1);
			}
			var clonedValue = { ...value };
			clonedValue.ipan_plan_kubun = ipan_plan_kubun;

			//const url = daichoURL() + `?ward=${ward}&town=${town}&hon=${hon}&eda=${eda}`;
			const url = daichoURL() + `/Search`;
			dbglog(url);
			fetch(url, {
				mode: 'cors',
				//				method: 'GET',
				method: 'POST',
				headers: {
					'Authorization': 'Bearer ' + this.token,
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(clonedValue)
			})
				.then((response) => {
					dbglog(response);
					if (response.ok) {
						return response.json();
					} else {
						return response.status;
					}
				})
				.then((in_data) => {
					var count = in_data.count;
					if(count > 10000) {
						this.dialog = true;
            this.dialogCategory = 1;
            this.dialogMsg = `検索条件に一致するデータが ${count} 件あります。条件を絞り込んで下さい。`;
						return;
					}
					var data = in_data.data;
					dbglog(data);
					//if (data.length) {
						this.$store.commit('setDaicho', data);
					//}
					this.$store.commit('setSearchMode', 0);
					this.$router.push('kamiresult');
				})
				.catch((err) => {
					dbglog(`Address.vue.searchChiban(): ${err}`);

				});
		},
		plotKey(layerFeature) {
			const k = layerFeature.feature ?? layerFeature;
			let result = k.get(this.plotDef.key);
			if (this.plotDefAlt !== null) {
				//if (result === undefined || result === null || result.length === undefined || result.length == 0) {
				if (!result) {
					result = k.get(this.plotDefAlt.key);
				}
			}
			return result;
		},
		isSelectedRow(k) {
			//const layer = k.layer;
			const feature = k.feature;
			const no = this.plotKey(feature);
			//const selNo = this.selectedNo;
			const selNo = this.selectedId;
			const hit = (no == selNo)
			//console.log(`k:${no} sel:${selNo} hit:${hit}`)
			return hit;
		},
		plotLabel(k) {
			const layer = k.layer;
			const feature = k.feature;
			let result = '不明';
			if (layer == 'vectorLayer') {
				result = feature.get(this.plotDef.label);
				if (!result)
					result = feature.get(this.plotDef.key);
			}
			else if (layer == 'vectorLayerAlt') {
				result = feature.get(this.plotDefAlt.label);
				if (!result) {
					result = feature.get(this.plotDefAlt.key);
				}
			}
			return result ?? '';
		},
		setMessage() {
			if (this.targetPlot) {
				this.$store.commit('setMessage', '　');
			}
			else {
				let addrText = `${this.wardName} ${this.townName}`;
				if (this.oyaban > 0) {
					addrText += ` ${this.oyaban}`;
					if (this.edaban > 0) {
						addrText += `-${this.edaban}`;
					}
				}
				this.$store.commit('setMessage', `地図検索：${addrText}`);
			}
		},
		// 呼び出される事がない？
		onMapSelectionChanged(selection) {
			//this.features = selection;
			//this.existsGaiyo = false;
			dbglog(`onMapSelectionChanged(${selection})`, -1);
			if (selection.length == 1) {
				dbglog(`MapPane: onMapSelectionChanged(${selection[0]})`, -1);
				this.selectRow(selection[0]);
			}
		},
		/**
		 * プロット一覧から特定の行を選択状態にする
		 * @param { PlotData } target 選択状態にするプロットデータ
		 */
		selectRow(target) {
			//test
			//this.targetPlotData = target.feature;
			//
			this.selectedLayer = target.layer;
			const selNo = this.plotKey(target);
			let selLabel = this.plotLabel(target);
			// 開発・造成・土石の堆積、指定道路用にSEQをselectedIdに保存
			//this.selectedNo = selNo;
			this.selectedId = selNo;
			this.selectedNo = selLabel;
			//開発・造成・土石の堆積の別を判定
			/*
			if (selNo != selLabel) {
				this.$store.commit('setSearchTargetType', selLabel.includes('規') ? 1 : 0);
			}
			*/
			this.$store.commit('setSearchTargetType', target.layer == 'vectorLayerAlt' ? 1 : 0);
			// 選択された番号の概要書データが存在するか調べて
			// 閲覧ボタンの使用可否を設定する（建築のみ）
			this.searchGaiyo(this.selectedNo, (data) => {
				this.existsGaiyo = (data && data.length);
			});
		},
		selectNendo(nendo) {
			dbglog(` selected: id=${nendo.id}, pageNo=${nendo.pageNo}, branch=${nendo.branch}`);
			this.$store.commit('setIndexId', nendo.id);
			this.$store.commit('setNendoName', nendo.name);
			//プロット地図画面の入力値をクリア
			this.$store.commit('setSearchYear', 0);
			this.$store.commit('setSearchBango', '');
			//
			this.$router.push({ name: 'plot-map', params: { sheet: nendo.pageNo } });
		},
		/**
		 * 現在選択されているプロットの概要書を表示する
		 */
		browse() {
			this.$store.commit('setUkeNo', this.selectedNo);
			this.$store.commit('setGaiyoId', this.selectedId);
			this.$router.push({ name: 'loading', params: { action: 1 } });
		},
		/**
		 * 指定された受付番号のデータを検索する
		 * （リスト選択時に閲覧ボタン使用可否を決定するために呼び出される）
		 * @param {String} ukeNo 受付番号
		 */
		searchGaiyo(ukeNo, callback) {
			if (ukeNo == null || ukeNo.length == 0) {
				this.existsGaiyo = false; //暫定措置
				return;
			}
			this.existsGaiyo = true; //暫定措置

			let url;
			if (this.mode == 1) {
				url = gaiyoURL() + '?uke_no=' + ukeNo;
			}
			else if (this.mode == 2) {
				//url = elvUrl() +  '?uke_no=' + ukeNo;
				return;
			}
			else {
				return;
			}
			dbglog(url);

			fetch(url, {
				mode: 'cors',
				method: 'GET',
				headers: {
					Authorization: 'Bearer ' + this.token,
				},
			})
				.then((response) => {
					dbglog(response);
					if (response.ok) {
						return response.json();
					}
					else {
						return response.status;
					}
				})
				.then((data) => {
					dbglog(data);
					if (data == 401) {
						this.loading = false;
						this.progressMessage = 'ユーザ認証に失敗しました。';
						this.authDialog = true;
						return;
					}
					callback(data);
				})
				.catch((err) => {
					dbglog(`MapPane.vue.searchGaiyo(${ukeNo}): ${err}`);
				});
		},
		onScroll(event) {
			//console.log(event.target.scrollTop);
			if (event.target.scrollTop == 200) {
				//console.log('in');
				document.getElementsByClassName('v-dialog__content')[0].style.height = '90%';
				document.getElementsByClassName('v-dialog__content')[0].style.bottom = '0';
				document.getElementsByClassName('v-dialog__content')[0].style.top = 'revert';
			} else if (event.target.scrollTop == 0) {
				document.getElementsByClassName('v-dialog__content')[0].style.height = '30%';
				document.getElementsByClassName('v-dialog__content')[0].style.bottom = '0';
				document.getElementsByClassName('v-dialog__content')[0].style.top = 'revert';
			}
		},
		touchUp() {
			if (document.querySelector('.v-bottom-sheet') != null) {
				document.querySelector('.v-bottom-sheet').style.height = '90%';
			}
		},
		touchDown() {
			if (document.querySelector('.v-bottom-sheet') != null) {
				document.querySelector('.v-bottom-sheet').style.height = '30%';
			}
		},
		toggleButton(index) {
			this.$set(this.isPressed, index, !this.isPressed[index]);
		},
		checkBox(index) {
			this.$set(this.isCheckedBox, index, !this.isCheckedBox[index]);
		},
		rcpYearSelected() {
      this.nen = null;
      for(let i = 0; i < this.eraYearList.length; i++){
        if(this.eraYearList[i].era == this.gengo){
          this.rcpYearItems = this.eraYearList[i].yearData;
        }
      }

			var daichoSearch = this.$store.state.daichoSearch;
			this.nen = daichoSearch.nen;

      //if(this.rcpYearItems.length != 0){
      //  this.nen = this.rcpYearItems[0];
      //}
    },
    /**
     * 確認年度入力の際、指定された元号によって入力アイテムが変わる処理 
     * 元号指定が変わった場合、選択済みの値は破棄される。
    */
    cnfYearSelected() {
      this.cnfYear.year = null;
      for(let i = 0; i < this.eraList.length; i++){
        if(this.eraList[i].era == this.cnfYear.era){
          this.cnfYearItems = this.eraList[i].yearData;
        }
      }
      if(this.cnfYearItems.length != 0){
        this.cnfYear.year = this.cnfYearItems[0];
      }
    },
	}
}
</script>
<style lang="scss" scoped>
.item-name {
	font-size: 16px;
	font-weight: 800;
}

.v-alert {
	font-size: 16px !important;
}

.v-input {
	font-size: 16px !important;
}

.v-text-field input {
	font-size: 16px !important;
}

button {
	font-size: 16px !important;
}
</style>